import {JSONAPIDocument} from "Models/JSONAPIDocument"
import WindowInterface from "Interfaces/WindowInterface"

declare const window: WindowInterface

class SearchAttributes {
  public zip: string
  public role: string = ''
  public distance: string = '30'
  public typeOfMentoring: string = 'all'
  public age: string = 'all'
  public grade: string = 'all'
  public youth: string = 'all'
  public focus: string = 'all'
  public howDidYouHearAboutUs: string
  public howDidYouHearAboutUsOther: string
  public lat: string
  public lng: string
  public partnerId: string = ''
  public national: boolean = false
  public firstName: string = ''
  public lastName: string = ''
  public email: string = ''
  public id: string
  public delivery = ["siteBased", "community", "eMentoring"]
  public nationwide: boolean = false

  load(row: any) {
    let attributes = row.data.attributes
    this.id = attributes.id
    // this.zip = attributes.field_zip
    this.distance = attributes.distance
    this.typeOfMentoring = JSON.parse(attributes.typeOfMentoring)[0]
    this.age = JSON.parse(attributes.age)[0]
    this.youth = JSON.parse(attributes.youth)[0]
    this.role = attributes.role
    this.focus = JSON.parse(attributes.focus)[0]
    // this.howDidYouHearAboutUs = attributes.field_how_did_you_hear_about_us
    // this.howDidYouHearAboutUsOther = attributes.field_how_did_you_hear_other
    // this.lat = attributes.field_physical_location?.lat
    // this.lng = attributes.field_physical_location?.lng
    this.grade = JSON.parse(attributes.grade)[0]
    this.delivery = []
    if(attributes.communityBasedDelivery == "1") {
      this.delivery.push('community')
    }
    if(attributes.siteBasedDelivery == "1") {
      this.delivery.push('siteBased')
    }
    if(attributes.eMentoringDelivery == "1") {
      this.delivery.push('eMentoring')
    }
  }
  serialize() {
    localStorage.setItem('firstName', this.firstName)
    localStorage.setItem('lastName', this.lastName)
    localStorage.setItem('email', this.email)
    localStorage.setItem('zip', this.zip)
    localStorage.removeItem('phone')
    localStorage.removeItem('call')
    localStorage.removeItem('sms')
    localStorage.setItem('role', this.role)
    localStorage.setItem('nationwide', this.nationwide)
    return {
      field_zip: this.zip,
      field_first_name: this.firstName,
      field_last_name: this.lastName,
      field_email: this.email,
      field_zip: !this.national ? this.zip : 'app-national',
      field_distance: this.distance,
      field_type_of_mentoring: this.typeOfMentoring,
      field_youth_age: this.age,
      field_youth: this.youth,
      field_role: this.role,
      field_focus: this.focus,
      field_how_did_you_hear_about_us: this.howDidYouHearAboutUs,
      field_how_did_you_hear_other: this.howDidYouHearAboutUsOther,
      field_partner_id: this.partnerId,
      field_youth_grade: this.grade,
      delivery: this.delivery,
      field_nationwide: this.nationwide,
    }
  }

}

export default class Search {

  public attributes: SearchAttributes = new SearchAttributes()
  public id;

  private type: string = 'node--search'
  private url: string = 'a/app/search'

  async save(): Promise<any> {
    let doc = new JSONAPIDocument()
    doc.type = this.type
    doc.attributes = this.attributes.serialize()
    doc.attributes.title = doc.attributes.field_email
    let response = await window.api.request({
      method: "POST",
      url: this.url,
      data: {
        data: doc
      }
    })
    this.id = response.data.data.id
    return response.data.data.id
  }

  async update() {
    let doc = new JSONAPIDocument()
    doc.type = this.type
    doc.id = this.id
    doc.attributes = this.attributes.serialize()
    await window.api.request({
      method: "PATCH",
      url: `${this.url}/${this.id}`,
      data: {
        data: doc
      }
    })
  }

  async load(id: string): Promise<any> {
    this.id = id
    let response = await window.api.request({
      url: `${this.url}/${id}`
    })
    this.attributes.load(response.data)
  }

}
